// extracted by mini-css-extract-plugin
export var cardIcon = "_ag-4";
export var checkboxCard = "_ag-0";
export var checkboxCardSelected = "_ag-3";
export var disabled = "_ag-1";
export var outerBorder = "_ag-2";
export var spacerMedium = "_ag-7";
export var spacerSmall = "_ag-6";
export var spacerXsmall = "_ag-5";